export default __webpack_public_path__ + "static/media/trip1.6acdb149.jpg";